/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  MatchRequest,
  MatchingPlaygroundRequestRequest,
  MatchingPlaygroundResponse,
  MatchingRunDetail,
  MatchingRunsStats,
  MatchingScoreDistribution,
  MatchingSettings,
  ModeratorsMatchingRunsListParams,
  ModeratorsMatchingScoresParams,
  PaginatedMatchingRunListItem,
  PatchedMatchingSettingsRequest
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Score the live catalog against an arbitrary query. Per-call weight overrides take precedence over the singleton settings; anything not overridden falls back to the singleton. Use this to A/B test weight changes before saving them globally.
 * @summary Run a matching engine query without persisting results
 */
export const moderatorsMatchingPlaygroundCreate = (
    matchingPlaygroundRequestRequest: MatchingPlaygroundRequestRequest,
 ) => {
      
      
      return customInstance<MatchingPlaygroundResponse>(
      {url: `/api/v1/moderators/matching/playground/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: matchingPlaygroundRequestRequest
    },
      );
    }
  


export const getModeratorsMatchingPlaygroundCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMatchingPlaygroundCreate>>, TError,{data: MatchingPlaygroundRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsMatchingPlaygroundCreate>>, TError,{data: MatchingPlaygroundRequestRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsMatchingPlaygroundCreate>>, {data: MatchingPlaygroundRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsMatchingPlaygroundCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsMatchingPlaygroundCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsMatchingPlaygroundCreate>>>
    export type ModeratorsMatchingPlaygroundCreateMutationBody = MatchingPlaygroundRequestRequest
    export type ModeratorsMatchingPlaygroundCreateMutationError = unknown

    /**
 * @summary Run a matching engine query without persisting results
 */
export const useModeratorsMatchingPlaygroundCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMatchingPlaygroundCreate>>, TError,{data: MatchingPlaygroundRequestRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsMatchingPlaygroundCreate>>,
        TError,
        {data: MatchingPlaygroundRequestRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsMatchingPlaygroundCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Paginated list of past match requests with audit-derived counters (event count, last stage, total duration). Use the drill-down endpoint to see the full event sequence for one run.
 * @summary List matching pipeline runs
 */
export const moderatorsMatchingRunsList = (
    params?: ModeratorsMatchingRunsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedMatchingRunListItem>(
      {url: `/api/v1/moderators/matching/runs/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsMatchingRunsListQueryKey = (params?: ModeratorsMatchingRunsListParams,) => {
    return [`/api/v1/moderators/matching/runs/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsMatchingRunsListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsMatchingRunsList>>, TError = unknown>(params?: ModeratorsMatchingRunsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsMatchingRunsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsMatchingRunsList>>> = ({ signal }) => moderatorsMatchingRunsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsMatchingRunsListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsMatchingRunsList>>>
export type ModeratorsMatchingRunsListQueryError = unknown

/**
 * @summary List matching pipeline runs
 */
export const useModeratorsMatchingRunsList = <TData = Awaited<ReturnType<typeof moderatorsMatchingRunsList>>, TError = unknown>(
 params?: ModeratorsMatchingRunsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsMatchingRunsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Drill-down for one match request: ordered list of pipeline events with stage, duration, metadata, and any error details.
 * @summary Get a single matching pipeline run
 */
export const moderatorsMatchingRunsDetail = (
    matchRequestId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MatchingRunDetail>(
      {url: `/api/v1/moderators/matching/runs/${matchRequestId}/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsMatchingRunsDetailQueryKey = (matchRequestId: number,) => {
    return [`/api/v1/moderators/matching/runs/${matchRequestId}/`] as const;
    }

    
export const getModeratorsMatchingRunsDetailQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsMatchingRunsDetail>>, TError = void>(matchRequestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsMatchingRunsDetailQueryKey(matchRequestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsMatchingRunsDetail>>> = ({ signal }) => moderatorsMatchingRunsDetail(matchRequestId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(matchRequestId),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsMatchingRunsDetailQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsMatchingRunsDetail>>>
export type ModeratorsMatchingRunsDetailQueryError = void

/**
 * @summary Get a single matching pipeline run
 */
export const useModeratorsMatchingRunsDetail = <TData = Awaited<ReturnType<typeof moderatorsMatchingRunsDetail>>, TError = void>(
 matchRequestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsDetail>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsMatchingRunsDetailQueryOptions(matchRequestId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Re-run matching for a failed match request (SC-MR01.9). Returns the request: `completed` with results, or `failed` again with a new reason if matching still can't run.
 * @summary Retry a failed matching run
 */
export const moderatorsMatchingRunsRetry = (
    matchRequestId: number,
 ) => {
      
      
      return customInstance<MatchRequest>(
      {url: `/api/v1/moderators/matching/runs/${matchRequestId}/retry/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsMatchingRunsRetryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsRetry>>, TError,{matchRequestId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsRetry>>, TError,{matchRequestId: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsMatchingRunsRetry>>, {matchRequestId: number}> = (props) => {
          const {matchRequestId} = props ?? {};

          return  moderatorsMatchingRunsRetry(matchRequestId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsMatchingRunsRetryMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsMatchingRunsRetry>>>
    
    export type ModeratorsMatchingRunsRetryMutationError = void

    /**
 * @summary Retry a failed matching run
 */
export const useModeratorsMatchingRunsRetry = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsRetry>>, TError,{matchRequestId: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsMatchingRunsRetry>>,
        TError,
        {matchRequestId: number},
        TContext
      > => {

      const mutationOptions = getModeratorsMatchingRunsRetryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Counters across two windows (last 7 days, last 30 days): total runs, successful runs (have a COMPLETED event in the window), failed runs (have a FAILED event in the window), and average total duration in milliseconds across successful runs.
 * @summary Matching pipeline run stats
 */
export const moderatorsMatchingRunsStats = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<MatchingRunsStats>(
      {url: `/api/v1/moderators/matching/runs/stats/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsMatchingRunsStatsQueryKey = () => {
    return [`/api/v1/moderators/matching/runs/stats/`] as const;
    }

    
export const getModeratorsMatchingRunsStatsQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsMatchingRunsStats>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsMatchingRunsStatsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsMatchingRunsStats>>> = ({ signal }) => moderatorsMatchingRunsStats(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsStats>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsMatchingRunsStatsQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsMatchingRunsStats>>>
export type ModeratorsMatchingRunsStatsQueryError = unknown

/**
 * @summary Matching pipeline run stats
 */
export const useModeratorsMatchingRunsStats = <TData = Awaited<ReturnType<typeof moderatorsMatchingRunsStats>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingRunsStats>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsMatchingRunsStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * D1-8: the minimum combined score in force and a 10-bucket histogram of every logged candidate score (`MatchingCandidateScore`) over the last `days` (default 30).
 * @summary Candidate score distribution (threshold calibration)
 */
export const moderatorsMatchingScores = (
    params?: ModeratorsMatchingScoresParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MatchingScoreDistribution>(
      {url: `/api/v1/moderators/matching/scores/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsMatchingScoresQueryKey = (params?: ModeratorsMatchingScoresParams,) => {
    return [`/api/v1/moderators/matching/scores/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsMatchingScoresQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsMatchingScores>>, TError = unknown>(params?: ModeratorsMatchingScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingScores>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsMatchingScoresQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsMatchingScores>>> = ({ signal }) => moderatorsMatchingScores(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingScores>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsMatchingScoresQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsMatchingScores>>>
export type ModeratorsMatchingScoresQueryError = unknown

/**
 * @summary Candidate score distribution (threshold calibration)
 */
export const useModeratorsMatchingScores = <TData = Awaited<ReturnType<typeof moderatorsMatchingScores>>, TError = unknown>(
 params?: ModeratorsMatchingScoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingScores>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsMatchingScoresQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Super-moderator control surface for the matching engine.

Two responsibilities:

1. **Settings** (`GET/PATCH /settings`) — read & update the
   `MatchingSettings` singleton (cosine vs structured weight, sub-
   weights, top_k, min_score_threshold). Edits flow into every match
   request created afterwards.
2. **Playground** (`POST /playground`) — run a query against the live
   catalog *without* persisting any MatchResult rows, with optional
   per-call weight overrides. Surfaces the engine's internal score
   breakdown (cosine, structured, final) per candidate so a moderator
   can tune weights with feedback in seconds, not deploys.

Super-mod gated; the moderator session lookup matches the rest of the
moderator panel.
 * @summary Read matching engine settings
 */
export const moderatorsMatchingSettingsRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<MatchingSettings>(
      {url: `/api/v1/moderators/matching/settings/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsMatchingSettingsRetrieveQueryKey = () => {
    return [`/api/v1/moderators/matching/settings/`] as const;
    }

    
export const getModeratorsMatchingSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsMatchingSettingsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingSettingsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsMatchingSettingsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsMatchingSettingsRetrieve>>> = ({ signal }) => moderatorsMatchingSettingsRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingSettingsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsMatchingSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsMatchingSettingsRetrieve>>>
export type ModeratorsMatchingSettingsRetrieveQueryError = unknown

/**
 * @summary Read matching engine settings
 */
export const useModeratorsMatchingSettingsRetrieve = <TData = Awaited<ReturnType<typeof moderatorsMatchingSettingsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsMatchingSettingsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsMatchingSettingsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Patch any subset of weights / top_k / min_score_threshold. The singleton is auto-created if it doesn't exist yet.
 * @summary Update matching engine settings
 */
export const moderatorsMatchingSettingsUpdatePartialUpdate = (
    patchedMatchingSettingsRequest: PatchedMatchingSettingsRequest,
 ) => {
      
      
      return customInstance<MatchingSettings>(
      {url: `/api/v1/moderators/matching/settings/update/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedMatchingSettingsRequest
    },
      );
    }
  


export const getModeratorsMatchingSettingsUpdatePartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMatchingSettingsUpdatePartialUpdate>>, TError,{data: PatchedMatchingSettingsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsMatchingSettingsUpdatePartialUpdate>>, TError,{data: PatchedMatchingSettingsRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsMatchingSettingsUpdatePartialUpdate>>, {data: PatchedMatchingSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsMatchingSettingsUpdatePartialUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsMatchingSettingsUpdatePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsMatchingSettingsUpdatePartialUpdate>>>
    export type ModeratorsMatchingSettingsUpdatePartialUpdateMutationBody = PatchedMatchingSettingsRequest
    export type ModeratorsMatchingSettingsUpdatePartialUpdateMutationError = unknown

    /**
 * @summary Update matching engine settings
 */
export const useModeratorsMatchingSettingsUpdatePartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsMatchingSettingsUpdatePartialUpdate>>, TError,{data: PatchedMatchingSettingsRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsMatchingSettingsUpdatePartialUpdate>>,
        TError,
        {data: PatchedMatchingSettingsRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsMatchingSettingsUpdatePartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    